import { Badge, ProgressBar, Stack } from 'react-bootstrap';
import { getStatusVariant } from './utils';

export interface BatchProgressProps {
    totalCount: number;
    completedCount: number;
    failedCount: number;
    status: string;
}

export function BatchProgress({ totalCount, completedCount, failedCount, status }: BatchProgressProps) {
    const safeTotalCount = totalCount > 0 ? totalCount : 0;
    const processedCount = completedCount + failedCount;
    const successPercent = safeTotalCount > 0 ? (completedCount / safeTotalCount) * 100 : 0;
    const failurePercent = safeTotalCount > 0 ? (failedCount / safeTotalCount) * 100 : 0;

    return (
        <Stack gap={3}>
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2">
                <div className="d-flex align-items-center gap-2">
                    <span className="fw-semibold">Status</span>
                    <Badge bg={getStatusVariant(status)}>{status}</Badge>
                </div>
                <span className="text-muted">{processedCount} / {safeTotalCount} processed</span>
            </div>
            <ProgressBar>
                <ProgressBar
                    now={successPercent}
                    variant="success"
                    key="success"
                    aria-label={`${completedCount} succeeded`}
                />
                <ProgressBar
                    now={failurePercent}
                    variant="danger"
                    key="failure"
                    aria-label={`${failedCount} failed`}
                />
            </ProgressBar>
        </Stack>
    );
}
